/*

<div class="control is-clearfix">
    <input type="text" v-mask="maskBelgianEnterprisenumber" v-model="editData.maskBelgianEnterprisenumber" class="input" :disabled="iniDisabled"/>
</div>

*/

import Vue from 'vue';
import Inputmask from 'inputmask';
const VueInputMask = {
    install: function (Vue, options) {
        Vue.directive('mask', {
            bind: function (el, binding) {
                Inputmask(binding.value).mask(el);
            },
        });
    },
};
Vue.use(VueInputMask);

export default {
    computed: {
        maskNationalnumber() {
            return {
                mask: '99.99.99-(9)|(a)99.99[.99.99]',
                autoUnmask: true,
                casing: 'upper',
                greedy: false,
            };
        },
        masBEkNationalnumberNoPrefix() {
            return {
                mask: '99.99.99-999.99',
                autoUnmask: true,
                casing: 'upper',
                greedy: false,
            };
        },
        maskBelgianEnterprisenumber() {
            return {
                mask: '9999.999.999',
                autoUnmask: true,
                casing: 'upper',
            };
        },
        maskIbanNumber() {
            //https://en.wikipedia.org/wiki/International_Bank_Account_Number
            var validMasks = [
                'BE 9{2} 9{4} *{4} 9{4}',
                'BG 9{2} 9{4} 9{4} 9{4} 9{4} 9{2}',
                'DK 9{2} 9{4} 9{4} 9{4} 9{2}',
                'DE 9{2} 9{4} 9{4} 9{4} 9{4} 9{2}',
                'EE 9{2} 9{4} 9{4} 9{4} 9{4}',
                'FI 9{2} 9{4} 9{4} 9{4} 9{2}',
                'FR 9{2} 9{4} 9{4} 9{4} 9{4} 9{4} 9{3}',
                'GR 9{2} 9{3} 9{4} 9{4} 9{4} 9{4} 9{4}',
                'IE 9{2} a{4} 9{4} 9{4} 9{4} 9{2}',
                'IS 9{2} 9{4} 9{4} 9{4} 9{4} 9{4} 9{2}',
                'IT 9{2} *{4} 9{4} 9{4} 9{4} 9{4} 9{3}',
                'IV 9{2} 9{4} 9{4} 9{4} 9{4} 9{1}',
                'LI 9{2} 9{4} 9{4} 9{4} 9{4} 9{1}',
                'LT 9{2} 9{4} 9{4} 9{4} 9{4}',
                'LU 9{2} 9{4} 9{4} 9{4} 9{4}',
                'MT 9{2} 9{4} 9{4} 9{4} 9{4} 9{4} 9{4} 9{4}',
                'MC 9{2} 9{4} 9{4} 9{4} 9{4} 9{4} 9{3}',
                'NL 9{2} a{4} 9{4} 9{4} 9{2}',
                'NO 9{2} 9{4} 9{4} 9{4}',
                '\\AT 9{2} 9{4} 9{4} 9{4} 9{4}',
                'PL 9{2} 9{4} 9{4} 9{4} 9{4} 9{4} 9{4}',
                'PT 9{2} 9{4} 9{4} 9{4} 9{4} 9{4} 9{1}',
                'RO 9{2} 9{4} 9{4} 9{4} 9{4} 9{4}',
                'SE 9{2} 9{4} 9{4} 9{4} 9{4} 9{4}',
                'CH 9{2} 9{4} 9{4} 9{4} 9{4} 9{1}',
                'SK 9{2} 9{4} 9{4} 9{4} 9{4} 9{4}',
                'SI 9{2} 9{4} 9{4} 9{4} 9{3}',
                'ES 9{2} 9{4} 9{4} 9{4} 9{4} 9{4}',
                'CZ 9{2} 9{4} 9{4} 9{4} 9{4} 9{4}',
                'HU 9{2} 9{4} 9{4} 9{4} 9{4} 9{4} 9{4}',
                'GB 9{2} a{4} 9{4} 9{4} 9{4} 9{2}',
                'CY 9{2} 9{4} 9{4} 9{4} 9{4} 9{4} 9{4}',
            ];
            const onUnMask = (maskedValue, unmaskedValue) => {
                var countryFormat = maskedValue.substr(0, 2);
                //add the countryFormat to the unmaskedValue!
                return countryFormat + unmaskedValue;
            };
            return {
                mask: validMasks,
                autoUnmask: true,
                keepStatic: false,
                casing: 'upper',
                onUnMask: onUnMask,
            };
        },
        maskCompanyNumber() {
            return {
                mask: '9999.999.999',
                autoUnmask: true,
            };
        },
    },
};
